import React from "react";
import Congrats from "../components/Congrats";
import { useLocation } from "react-router-dom";
import TicketCard from "../components/Ticketcard";

const Ticket = () => {
    const location = useLocation();
    const { fullName, email, githubUsername } = location.state || {};

    const fileBase64 = sessionStorage.getItem('uploadedFile');

    return (
        <div className="flex flex-col items-center justify-center gap-4">
            <Congrats fullName={fullName}
                email={email}
                />
            <TicketCard fileBase64={fileBase64} fullName={fullName} githubUsername={githubUsername}/>
        </div>
    )
}

export default Ticket